export { default as IconExit } from './icon-exit.svg';
